var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeverMarried(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_521_28326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 18,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48639 3.5C4.00868 3.5 2 5.50868 2 7.9864C2 12.4728 7.3021 16.5513 10.1571 17.5C13.0121 16.5513 18.3142 12.4728 18.3142 7.9864C18.3142 5.50868 16.3055 3.5 13.8278 3.5C12.3105 3.5 10.9687 4.25331 10.1571 5.40631C9.74339 4.81705 9.1938 4.33614 8.55484 4.00431C7.91588 3.67248 7.20638 3.49949 6.48639 3.5Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70993 10.4335H12.6042M10.1571 7.98633V12.8806",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_521_28326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.368561 0.645508H19.9456V20.2225H0.368561V0.645508Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeverMarried);
export default __webpack_public_path__ + "static/media/never-married.b2545cb627bc23f4aad4a8170c243941.svg";
export { ForwardRef as ReactComponent };